import Settings from "./CarrotConfig"
import { APP_ENVS, type AppEnv } from "@carrot/shared-config"

/**
 * Which deployment environment the app is running in, per the runtime config
 * loaded from /config.js before the bundle (see index.html).
 *
 * This is deliberately NOT `process.env.NODE_ENV` / `import.meta.env.PROD`.
 * CI builds the JS artifact exactly once and the publish step only swaps
 * config.js per environment (.github/workflows/front-end-build.yml), so every
 * build-time flag reads "production" on the stage artifact too. `window.env.ENV`
 * is the only thing that tells stage and production apart at runtime.
 */
export function getAppEnv(): AppEnv | null {
  const raw = Settings.ENV
  return APP_ENVS.includes(raw as AppEnv) ? (raw as AppEnv) : null
}

/**
 * Fails CLOSED: a missing or unrecognized ENV counts as production. Gating that
 * fails open leaks internal surfaces into production; gating that fails closed
 * is a local annoyance with an obvious cause.
 */
export function isProductionEnv(): boolean {
  const env = getAppEnv()
  return env === null || env === "production"
}
